export default class ImageLoader {
    public load(): void {
        const imageElements = [...document.querySelectorAll('[data-src]')].map(x => x as HTMLElement);
        imageElements.forEach(element => {
            element.dataset.src && element.setAttribute('src', element.dataset.src);
        });
    }
}
